import { create } from "zustand";

/**
 * Which "hat" a dual-role user is currently wearing in the vault app.
 *
 * Most users are only an owner OR only a heir, in which case the mode is implied
 * and this store is unused. A user who is both (owns their own vault and is a
 * trustee of someone else's) picks a mode on the home screen; the choice is
 * remembered across reloads so they don't re-pick every visit. `useVaultMode`
 * reconciles this stored value against the roles actually present on the token.
 */
export type VaultMode = "owner" | "heir";

interface VaultModeState {
  activeMode: VaultMode | null;
  setActiveMode: (mode: VaultMode | null) => void;
}

const STORAGE_KEY = "vault_active_mode";

const initialMode: VaultMode | null =
  typeof window !== "undefined"
    ? ((localStorage.getItem(STORAGE_KEY) as VaultMode | null) ?? null)
    : null;

export const useVaultModeStore = create<VaultModeState>((set) => ({
  activeMode: initialMode,
  setActiveMode: (mode) => {
    if (typeof window !== "undefined") {
      if (mode) localStorage.setItem(STORAGE_KEY, mode);
      else localStorage.removeItem(STORAGE_KEY);
    }
    set({ activeMode: mode });
  },
}));
